import type { DeepReadonly } from "core/types"

export function createDeepReadonlyStoreField<T>(field: Ref<T>) {
  return computed<DeepReadonly<T>>(() => field.value)
}
